<!-- Menu header -->

<div style="background-color: #020626 " class="">
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto"></li>
    </ul>
</div>
<!--/ Menu header -->

<!-- Navbar shadow -->
<div style="background-color: #020626 " class="shadow-bottom" [ngClass]="{ 'd-block': isScrolled  }"></div>

<div class="vertical-menu-shell">
  <!-- Main menu -->
  <div style="background-color: #020626; height: 100%" class="main-menu-content vertical-menu-scroll" [perfectScrollbar] (scroll)="onSidebarScroll()">
    <ul style="background-color: #020626 " class="navigation navigation-main" layout="vertical" core-menu></ul>
  </div>
  <!--/ Main menu -->

  <div class="lc-menu-pin-bar">
    <button
      type="button"
      class="lc-menu-pin-bar__btn"
      (click)="toggleMenuPinned()"
      [attr.title]="menuPinLabel"
      [attr.aria-label]="menuPinLabel"
    >
      <span [attr.data-feather]="menuPinIcon"></span>
      <span class="lc-menu-pin-bar__label">{{ menuPinLabel }}</span>
    </button>
  </div>
</div>
